import { render, staticRenderFns } from "./DefaultContainer.vue?vue&type=template&id=a98b7696"
import script from "./DefaultContainer.vue.ts?vue&type=script&lang=ts&external"
export * from "./DefaultContainer.vue.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports